// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contBox[data-v-772a9eb0] {\n  padding: 20px;\n  min-height: 400px;\n}", ""]);
// Exports
module.exports = exports;
